import { PasscodeListsState } from './types';

export const initialState: PasscodeListsState = {
  passcodeList: null,
  loadingPasscodeList: false,
  loadingPasscodeListId: undefined,

  passcodeLists: [],
  loadingPasscodeLists: false,
  loadedPasscodeLists: false,

  passcodeListMembers: [],
  loadingPasscodeListMembers: false,
  loadingPasscodeListMembersListIds: [],

  passcodelistMemberListId: null,

  passcodeListMemberCount: 0,
  loadingPasscodeListMemberCount: false,

  passcodeListAssociatedEvents: [],
  passcodeListAssociatedEventsDetails: [],
  loadingPasscodeListAssocEvents: [],
  loadingPasscodeListAssocEventsDetails: [],

  memberPasscodeLists: {},
  loadingMemberPasscodeLists: false,

  magicLinkRegistrationsPasscodeList: null,

  passcodeListMemberRegistrantDetails: {},
};
